import { View } from 'react-native';
import { Icon } from '@/components/Icon';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { Text } from '@/components/ui/therapist/Text';

import colors from '@/config/colors';
import { styles } from '@/components/Template/styles';

type EmptyTempalteProps = {
  setShowSetTypeModal: () => void;
};

export const EmptyTemplate = ({ setShowSetTypeModal }: EmptyTempalteProps) => {
  return (
    <View style={styles.emptyTemplateWrapper}>
      <View style={styles.emptyTemplateButtonWrapper}>
        <PressableNeolexon
          style={styles.emptyTemplateButton}
          onPress={setShowSetTypeModal}
        >
          <Icon
            name="plus"
            color={colors.newUI.therapist.primaryBlue80}
            size={40}
          />
        </PressableNeolexon>
        <Text style={{ paddingTop: 8 }}>Neue Vorlage erstellen</Text>
      </View>
    </View>
  );
};
